import {siteOrigin, backendUrl} from "../../globalConfig";
import {AppDispatch} from "../../redux/store";
import {dashboardElementsSlice} from "../../redux/dashboardElementsReducer";


export const getDashboardElements = () => async (dispatch: AppDispatch) => {
    fetch(backendUrl+'/dashboard/dashboard_elements_get', {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': siteOrigin
        }
    })
        .then((r) =>  {
            if(r.status===200){
                return r.json().then(data => ({status: r.status, json: data}))
            } else {
                let error = new Error(r.statusText);
                throw error
            }
        })
        .then((data) => {
            if (data.status===200){
                dispatch(dashboardElementsSlice.actions.updateDashboardElementsArray(data.json))
            }
        })
        .catch((e) => {
            console.log('Error: ' + e.message);
        })
}